import { useController } from 'react-hook-form';
import {
  UncontrolledSegmentedButtonParent,
  UncontrolledSegmentedButtonChildren,
} from 'components/Form';

import { defaultDetail } from './VenueDetail';

const t = {
  requirements: {
    liftgate: 'Liftgate',
  },
  mode: {
    accepted: 'Accepted',
    not_accepted: 'Not accepted',
    required: 'Required',
  },
};

const VenueVehicleRequirement = ({ label, name, fieldName, defaultValue, fieldModes, error }) => {
  const { field } = useController({
    name: `${fieldName}.${name}`,
    defaultValue: defaultValue,
    shouldUnregister: false,
    rules: {
      required: 'Select a value',
    },
  });

  return (
    <div className="vehicle-requirements">
      <div>{label}</div>
      <UncontrolledSegmentedButtonParent>
        {Object.keys(fieldModes).map((mode) => (
          <UncontrolledSegmentedButtonChildren
            key={mode}
            id={mode}
            {...field}
            value={mode}
            defaultChecked={defaultValue === mode}
            hasError={!!error?.message}
          >
            {fieldModes[mode]}
          </UncontrolledSegmentedButtonChildren>
        ))}
      </UncontrolledSegmentedButtonParent>
      {!!error?.message && <div className="field-error left-margin">{error.message}</div>}
    </div>
  );
};

const VenueVehicleRequirementsRenderer = ({
  value: vehicleRequirements,
  fieldName,
  isEditing,
  error,
}) => {
  if (isEditing) {
    return (
      <>
        {Object.keys(t.requirements).map((requirement) => (
          <VenueVehicleRequirement
            key={requirement}
            name={requirement}
            label={t.requirements[requirement]}
            fieldName={fieldName}
            fieldModes={t.mode}
            defaultValue={(vehicleRequirements || {})[requirement]}
            error={(error || {})[requirement]}
          />
        ))}
      </>
    );
  }

  const vehicleRequirementsKeys = Object.keys(vehicleRequirements || {});

  if (!vehicleRequirementsKeys.length) {
    return <>{defaultDetail}</>;
  }

  return (
    <div>
      {vehicleRequirementsKeys.map((requirement) => (
        <div key={requirement}>
          <>{t.requirements[requirement] || requirement}:</>{' '}
          <>{t.mode[vehicleRequirements[requirement]] || vehicleRequirements[requirement]}</>
        </div>
      ))}
    </div>
  );
};

export default VenueVehicleRequirementsRenderer;
